<template>
  <div>
    <div class="btn-group">
      <!-- <eui-btn @click="getData" type="weak">获取数据</eui-btn> -->
      <eui-btn type="weak" @click="addYear">新增财务年份</eui-btn>
      <!-- <eui-btn type="weak" @click="addYear">导出模版</eui-btn>
      <eui-btn type="weak" @click="addYear">导入模版</eui-btn> -->
    </div>

    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column prop="date" label="序号" width="80" align="center">
        <template slot-scope="scope">
          <div>
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="指标(万元)"
        align="center"
      ></el-table-column>
      <!-- <el-table-column v-for="(col, index) in dynamicColumns" :key="index" :prop="col.prop" :label="col.label"></el-table-column> -->

      <el-table-column
        v-for="(col, index) in yearsList"
        :key="index"
        align="center"
      >
        <template slot="header" slot-scope="scope">
          <div class="header-content">
            <div>
              <span style="margin-right: 10px">年份</span>
              <el-select
                v-model="col.value"
                style="width: 100px"
                placeholder="请选择"
                @change="
                  (val) => {
                    handleChangeYear(val, index);
                  }
                "
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <eui-btn
              v-if="index !== 0"
              square
              type="text"
              icon="eicon-delete"
              @click="handleDeletedYear(index)"
            ></eui-btn>
          </div>
        </template>
        <template slot-scope="scope">
          <el-form :model="scope.row" :rules="rules" size="small" inline>
            <el-form-item
              :key="scope.row.dataList[index].label"
              label=""
              :prop="'dataList.' + index + '.num'"
              :rules="{
                required: true,
                message: '数据不能为空',
                trigger: 'blur',
              }"
            >
              <el-input
                v-model="scope.row.dataList[index].num"
                @input="
                  () => {
                    handleInput(
                      scope.row.dataList[index].num,
                      scope.$index,
                      index
                    );
                  }
                "
              ></el-input>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    supplierId: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      options: [
        {
          value: '2019',
          label: '2019',
        },
        {
          value: '2020',
          label: '2020',
        },
        {
          value: '2021',
          label: '2021',
        },
        {
          value: '2022',
          label: '2022',
        },
        {
          value: '2023',
          label: '2023',
        },

        {
          value: '2024',
          label: '2024',
        },
        {
          value: '2025',
          label: '2025',
        },
      ],
      value: '',
      yearsList: [
        {
          value: '2019',
          label: '年份',
        },
      ],
      tableData: [
        {
          name: '总资产',
          num: null,
          label: 'totalAssets',
          dataList: [{ label: '2019', num: null }],
        },
        {
          name: '营业收入',
          num: null,
          label: 'operatingRevenue',
          dataList: [{ label: '2019', num: null }],
        },
        {
          name: '流动资产',
          num: null,
          label: 'currentAssets',
          dataList: [{ label: '2019', num: null }],
        },
        {
          name: '总负债',
          num: null,
          label: 'totalLiabilities',
          dataList: [{ label: '2019', num: null }],
        },
        {
          name: '流动负债',
          num: null,
          label: 'currentLiabilities',
          dataList: [{ label: '2019', num: null }],
        },
        {
          name: '固定资产原值',
          num: null,
          label: 'fixedAssetsOriginalValue',
          dataList: [{ label: '2019', num: null }],
        },
        {
          name: '固定资产期末净值',
          num: null,
          label: 'fixedAssetsNetValue',
          dataList: [{ label: '2019', num: null }],
        },
        {
          name: '流动资金期末净值',
          num: null,
          label: 'currentAssetsNetValue',
          dataList: [{ label: '2019', num: null }],
        },
        {
          name: '净利润',
          num: null,
          label: 'netProfit',
          dataList: [{ label: '2019', num: null }],
        },
        {
          name: '利润率%',
          num: null,
          label: 'profitMargin',
          dataList: [{ label: '2019', num: null }],
        },
        {
          name: '营业毛利率%',
          num: null,
          label: 'operatingMargin',
          dataList: [{ label: '2019', num: null }],
        },
        {
          name: '资产负债率%',
          num: null,
          label: 'assetLiabilityRatio',
          dataList: [{ label: '2019', num: null }],
        },
        {
          name: '流动比率%',
          num: null,
          label: 'currentRatio',
          dataList: [{ label: '2019', num: null }],
        },
        {
          name: '对外担保金额',
          num: null,
          label: 'externalGuaranteeAmount',
          dataList: [{ label: '2019', num: null }],
        },
      ],
      rules: {
        num: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
    };
  },
  methods: {
    // 编辑时初始化数据
    editInitData(val) {
      console.log(val);
      this.initYearList(val);
      this.initTableData(val);
      console.log(this.tableData);
    },
    initYearList(list) {
      this.yearsList = [];
      for (let i = 0; i < list.length; i++) {
        this.yearsList.push({
          label: '年份',
          value: list[i].year,
        });
      }
      console.log(this.yearsList);
    },
    initTableData(list) {
      this.tableData.forEach((item) => {
        item.dataList = [];
        list.forEach((item2) => {
          const obj = {};
          obj.label = item2.year;
          obj.num = item2[item.label]
            ? Number(item2[item.label]).toFixed(2)
            : '';
          item.dataList.push(obj);
        });
      });
    },
    addYear() {
      console.log(this.supplierId);
      if (this.supplierId === '' || this.supplierId === null) {
        this.$message.warning('请先选择供应商');
        return;
      }
      const year = this.yearsList[this.yearsList.length - 1].value;
      const yearNum = Number(year) + 1;
      this.yearsList.push({
        value: yearNum,
        label: '年份',
      });
      this.tableData.map((item) => {
        item.dataList.push({ label: yearNum, num: null });
      });
      this.$emit('handleYearChange', this.yearsList);
    },
    getData() {
      const data = [];
      const len = this.yearsList.length;
      for (let i = 0; i < len; i++) {
        const obj = {};
        this.tableData.forEach((item) => {
          obj[item.label] = item.dataList[i].num;
        });
        obj.year = this.yearsList[i].value;
        data.push(obj);
      }
      console.log(data);
      return data;
    },
    handleDeletedYear(index) {
      // const year = this.yearsList[index].value;
      this.yearsList.splice(index, 1);
      console.log(this.yearsList);
      this.$emit('handleYearChange', this.yearsList);
    },
    //  选择年份
    handleChangeYear(val, index) {
      this.yearsList[index].value = val;
      this.tableData.forEach((item) => {
        item.dataList[index].label = val;
      });
      console.log(this.yearsList);
      console.log(this.tableData);
      this.$emit('handleYearChange', this.yearsList);
    },
    getYearsList() {
      return this.yearsList;
    },
    handleInput(value, rowIndex, index) {
      // 正则表达式：匹配正数、负数和小数
      const regex = /^-?\d*(\.\d*)?$/;
      if (!regex.test(value)) {
        // 如果输入值不符合规则，去掉不合法字符
        this.tableData[rowIndex].dataList[index].num = value.replace(
          /[^-?\d.]/g,
          ''
        );
      } else {
        // 确保只有一个小数点
        this.tableData[rowIndex].dataList[index].num = value;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-group {
  display: flex;
  flex-flow: row;
  margin: 20px 0 10px 0;
}
::v-deep.el-form-item--small.el-form-item {
  margin-bottom: 0;
}
::v-deep.el-table .cell {
  font-size: 14px;
}
.header-content {
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
}
</style>
